/* eslint-disable no-underscore-dangle */
import http from '@/tool/http/http'

function service() {
  const Services = {}
  // 单位-报酬审核列表
  Services._jobSalaryList = data => http.POST('/api/salary/jobSalaryList', data)
  // 学工-报酬审核列表
  Services._schoolSalaryList = data => http.POST('/api/salary/schoolSalaryList', data)
  // 发放审核工资列表
  Services._schoolSalaryListIn = data => http.POST('/api/salary/schoolSalaryListIn', data)
  // 学校驳回
  Services._rejectSalary = data => http.POST('/api/salary/rejectSalary', data)
  // 单位/学工-学生报酬审核列表
  Services._studentSalaryList = data => http.POST('/api/salary/studentSalaryList', data)
  // 单位/学工-月报酬发放填写
  Services._studentSalaryListIn = data => http.POST('/api/salary/studentSalaryListIn', data)
  // 导出
  Services._studentSalaryOut = data => http.POST('/api/salary/studentSalaryOut', data)
  // 单位提交到学院审核
  Services._submitSalaryToSchool = data => http.POST('/api/salary/submitSalaryToSchool', data)
  // 学生审核列表
  Services._studentHistorySalaryList = data => http.POST('/api/salary/studentHistorySalaryList', data)
  // 单个储存学生数据
  Services._saveStudentSalaryTemp = data => http.POST('/api/salary/saveStudentSalaryTemp', data)
  // 审核完成
  Services._salaryFinishCheck = data => http.POST('/api/salary/salaryFinishCheck', data)
  // 生成报表
  Services._ReportStudentExcl = data => http.GET(`/api/salary/ReportStudent/${data}`)
  // 查询重复名单的学生
  Services._repeatStudentList = data => http.POST('/api/salary/repeatStudent', data)
  // 删除重复学生名单
  Services._deleteRepeatStudent = data => http.POST('/api/salary/deleteRepeatStudent', data)
  // 恢复重复学生名单
  Services._recoverRepeatJobSalary = data => http.POST('/api/salary/recoverRepeatJobSalary', data)
  return Services
}
export default service
